import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect } from 'react';

import { removeState } from 'Utilities/LocalStorage';

import { TOKEN_SESSION_KEY } from './CONSTANTS';

const LoginPage: React.FC = () => {
	const { keycloak } = useKeycloak();

	const onLogin = () => {
		if (!keycloak.authenticated) keycloak.login();
	};
	useEffect(() => {
		removeState(TOKEN_SESSION_KEY);
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		onLogin();
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>;
};
export default LoginPage;
